import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { Menu, X, Home, User, Code, Briefcase, Mail, FileText, Award } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Accueil', to: 'home', icon: <Home size={18} /> },
    { name: 'À propos', to: 'about', icon: <User size={18} /> },
    { name: 'Compétences', to: 'skills', icon: <Code size={18} /> },
    { name: 'Projets', to: 'projects', icon: <Briefcase size={18} /> },
    { name: 'Expérience', to: 'experience', icon: <Award size={18} /> },
    { name: 'Contact', to: 'contact', icon: <Mail size={18} /> },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-dark/95 backdrop-blur-md py-3 shadow-xl' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link 
            to="home" 
            smooth={true} 
            duration={500}
            className="text-2xl font-bold text-white cursor-pointer hover:text-primary transition-colors flex items-center gap-2"
          >
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Code size={18} />
            </div>
            <span>Yannick HIEN<span className="text-primary">.</span></span>
          </Link>

          {/* Navigation Desktop */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.to}
                smooth={true}
                duration={500}
                spy={true}
                offset={-80}
                activeClass="text-primary bg-gray-800/30"
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-gray-300 hover:text-primary hover:bg-gray-800/50 cursor-pointer transition-all duration-300"
              >
                {item.icon}
                {item.name}
              </Link>
            ))}
            
            {/* Bouton CV */}
            <a
              href="/CV Yannick.pdf"
              className="ml-4 bg-primary text-white px-6 py-2 rounded-lg hover:bg-secondary transition-all hover:scale-105 flex items-center gap-2 shadow-lg"
              download
            >
              <FileText size={18} />
              CV
            </a>
          </div>

          {/* Bouton Menu Mobile */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Menu Mobile */}
        {isOpen && (
          <div className="md:hidden mt-4">
            <div className="flex flex-col space-y-2 bg-gray-900/95 backdrop-blur-lg rounded-xl p-4 shadow-2xl border border-gray-800">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                  activeClass="text-primary bg-gray-800/30"
                  className="flex items-center gap-3 text-gray-300 hover:text-primary py-3 px-4 rounded-lg hover:bg-gray-800 cursor-pointer transition-all"
                  onClick={() => setIsOpen(false)}
                >
                  {item.icon}
                  {item.name}
                </Link>
              ))}
              
              <a
                href="/CV Yannick.pdf"
                className="flex items-center gap-3 bg-primary text-white py-3 px-4 rounded-lg hover:bg-secondary transition-all mt-2"
                download
                onClick={() => setIsOpen(false)}
              >
                <FileText size={18} />
                Télécharger mon CV
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;